import { useState } from 'react'
import useEdgeDataFetcher from './useEdgeDataFetcher'

export default offerId => {
  const [dealerId, sendOffer] = useState(false)
  let sent = dealerId && 'Sending'
  const response = useEdgeDataFetcher(offerId && dealerId && `/offers/${offerId}/dealer/${dealerId}?a=b`, ' ', 'POST')
  sent = dealerId && response ? 'Sent' : undefined
  return [sent, sendOffer]
}
